import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=931cc974&scoped=true&"
import script from "./FormTextArea.vue?vue&type=script&lang=ts&"
export * from "./FormTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./FormTextArea.vue?vue&type=style&index=0&id=931cc974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931cc974",
  null
  
)

export default component.exports